// extracted by mini-css-extract-plugin
export default {"InsertMenu":"InsertButtonMenus_InsertMenu__dDylQ"};